import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { withTranslation } from 'react-i18next';
import MaterialIcon from 'material-icons-react';

import './ModalExitTask.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

class ModalExitTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: !!sessionStorage.getItem('taskInProgress'),
    };

    this.closeModal = this.closeModal.bind(this);
    this.closeWithConfirmModal = this.closeWithConfirmModal.bind(this);
  }

  componentDidUpdate() {
    const taskInProgress = !!sessionStorage.getItem('taskInProgress');
    if (taskInProgress !== this.state.modalIsOpen) {
      this.setState({
        modalIsOpen: taskInProgress,
      });
    }
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
    this.props.onClose();
  }

  closeWithConfirmModal() {
    this.setState({
      modalIsOpen: false,
    });
    sessionStorage.removeItem('taskInProgress');
    // sessionStorage.removeItem('roomUpdated');
    this.props.onConfirm();
  }

  render() {
    return (
      <ReactModal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        contentLabel="Modal">
        <div className="modal-container">
          <span className="in-active-color">
            <MaterialIcon size="large" icon="error_outline" />
          </span>
          <h4 className="text-center mt-2">
            {this.props.t('taskManagement.exitTaskModal.headline')}
          </h4>
          <p>{this.props.t('taskManagement.exitTaskModal.message')}</p>
          <div className="buttons-container w-100">
            <button className="btn btn-action w-25" onClick={this.closeModal}>
              {this.props.t('common.labels.no')}
            </button>
            <button className="btn btn-action w-25" onClick={this.closeWithConfirmModal}>
              {this.props.t('common.labels.yes')}
            </button>
          </div>
        </div>
      </ReactModal>
    );
  }
}

ModalExitTask.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ModalExitTask);
